import React from 'react';
import black from './logo-black';
import white from './logo-white';

const Logo = ({ variant = 'black', className = 'gf-logo' }) => (
  <span className={`${className} gf-logo-${variant}`} dangerouslySetInnerHTML={{ __html: variant === 'white' ? white : black }} />
);
export default Logo;
